/* ==========================================================================
   Perfumer's Story Section — Animation Controller
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pointerFine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;

  function initSection(section) {
    var staggerBase = parseInt(section.getAttribute('data-ps-stagger'), 10) || 0;
    var revealItems = section.querySelectorAll('[data-ps-reveal]');

    /* ---------- Staggered reveal ---------- */
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var index = parseInt(entry.target.getAttribute('data-ps-index'), 10) || 0;
            var delay = staggerBase * index;
            setTimeout(function () {
              entry.target.classList.add('is-visible');
            }, delay);
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });

      revealItems.forEach(function (el) { revealObserver.observe(el); });
    }

    if (reduceMotion) return;

    /* ---------- Parallax ---------- */
    var parallaxEnabled = section.getAttribute('data-ps-parallax') === 'true';
    var parallaxIntensity = parseInt(section.getAttribute('data-ps-parallax-intensity'), 10) || 0;

    if (parallaxEnabled && parallaxIntensity > 0) {
      var frameEl = section.querySelector('[data-ps-tilt-target]');
      var secondaryImage = section.querySelector('[data-ps-parallax-secondary]');
      var ticking = false;
      var active = false;

      function updateParallax() {
        var rect = section.getBoundingClientRect();
        var viewportH = window.innerHeight || document.documentElement.clientHeight;
        var progress = (viewportH - rect.top) / (viewportH + rect.height); // 0 -> 1 across viewport pass
        progress = Math.max(0, Math.min(1, progress));
        var offset = (progress - 0.5) * 2 * parallaxIntensity; // -intensity .. +intensity

        if (frameEl) {
          frameEl.style.transform = 'translate3d(0,' + (offset * 0.6).toFixed(2) + 'px,0)';
        }
        if (secondaryImage) {
          secondaryImage.style.setProperty('--ps-parallax-y', (-offset * 1.1).toFixed(2) + 'px');
        }
        ticking = false;
      }

      function onScroll() {
        if (!active || ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateParallax);
      }

      var parallaxObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          active = entry.isIntersecting;
          if (active) {
            window.addEventListener('scroll', onScroll, { passive: true });
            updateParallax();
          } else {
            window.removeEventListener('scroll', onScroll);
          }
        });
      }, { threshold: 0 });

      parallaxObserver.observe(section);
    }

    /* ---------- Tilt 3D ---------- */
    var tiltEnabled = section.getAttribute('data-ps-tilt') === 'true';
    var tiltIntensity = parseInt(section.getAttribute('data-ps-tilt-intensity'), 10) || 0;

    if (tiltEnabled && tiltIntensity > 0 && pointerFine) {
      var tiltTarget = section.querySelector('[data-ps-tilt-target]');
      var tiltImage = section.querySelector('[data-ps-tilt-image]');

      if (tiltTarget && tiltImage) {
        tiltTarget.addEventListener('mousemove', function (e) {
          var rect = tiltTarget.getBoundingClientRect();
          var x = (e.clientX - rect.left) / rect.width - 0.5;
          var y = (e.clientY - rect.top) / rect.height - 0.5;
          var rotateY = x * tiltIntensity;
          var rotateX = y * -tiltIntensity;
          tiltImage.style.transition = 'transform 0.1s ease-out';
          tiltImage.style.transform = 'rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg) scale(1.04)';
        });

        tiltTarget.addEventListener('mouseleave', function () {
          tiltImage.style.transition = 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
          tiltImage.style.transform = 'rotateX(0deg) rotateY(0deg) scale(1)';
        });
      }
    }
  }

  function init() {
    var sections = document.querySelectorAll('[data-ps-section]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-ps-section]');
    if (section) initSection(section);
  });
})();

